// eslint-disable-next-line boundaries/external
import { FormArray, FormGroup } from '@angular/forms';

export interface ErrorMappingI {
  pattern: string;
  key: string;
}

export interface BackendError {
  [fieldName: string]: string | string[];
}

export function mapBackendErrorsToFormControls(
  formArray: FormArray<FormGroup>,
  errorsArray: BackendError[],
  errorDictionary?: ErrorMappingI[],
): void {
  const basicErrorDictionary: ErrorMappingI[] = [
    { pattern: 'has already been taken', key: 'alreadyTaken' },
  ];

  errorsArray.forEach((employeeError: BackendError, index: number) => {
    const formGroup = formArray.at(index);

    if (!formGroup) return;

    Object.keys(employeeError).forEach(fieldName => {
      const fieldControl = formGroup.get(fieldName);
      const fieldErrors = employeeError[fieldName];

      if (fieldControl && fieldErrors) {
        const errorMessages = Array.isArray(fieldErrors) ? fieldErrors : [fieldErrors];
        const errorMessage = errorMessages[0]?.toLowerCase() || '';

        const errorKey = [...basicErrorDictionary, ...(errorDictionary || [])].find(({ pattern }) =>
          errorMessage.includes(pattern),
        )?.key;

        if (errorKey) {
          fieldControl.setErrors({
            ...fieldControl.errors,
            [errorKey]: true,
          });
          fieldControl.markAsTouched();
        }
      }
    });
  });
}
